import { render } from "./SharingHistoryComp.vue?vue&type=template&id=a3762034&scoped=true"
import script from "./SharingHistoryComp.vue?vue&type=script&lang=js"
export * from "./SharingHistoryComp.vue?vue&type=script&lang=js"

import "./SharingHistoryComp.vue?vue&type=style&index=0&id=a3762034&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3762034"]])

export default __exports__